export default __webpack_public_path__ + "static/media/natural-resources.a4776ced.png";